import React from 'react';
import cn from 'classnames';
import { NavLink } from 'react-router-dom';

export const BreadCrumbGroup: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <nav className="flex space-x-2">
      {React.Children.map(children, (child, index) => {
        if (index > 0) {
          return (
            <div className="space-x-1">
              <span className="text-gray-700">/</span>
              {child}
            </div>
          );
        }

        return <div>{child}</div>;
      })}
    </nav>
  );
};

export const BreadCrumbItem: React.FC<{
  children: React.ReactNode;
  to: string;
}> = ({ children, to }) => {
  return (
    <NavLink
      end
      to={to}
      className={({ isActive }) => {
        return cn({
          'text-gray-700': !isActive,
          'text-gray-900 font-semibold': isActive,
        });
      }}
    >
      {children}
    </NavLink>
  );
};
